module.exports = __webpack_public_path__ + "static/media/score20.613985a0.svg";